import { TFormField, FormFieldType } from '@models/forms';

export const getFormFields = ({
  isRequired = true,
  defaultValue,
}: {
  isRequired?: boolean;
  defaultValue?: string;
} = {}): { [fieldName: string]: TFormField } => ({
  email: {
    gridWidth: { xs: 12 },
    name: 'email',
    label: 'Email Address',
    fieldType: FormFieldType.TextField,
    required: isRequired,
    defaultValue,
    placeholder: 'example@email.com',
    fieldConfig: {
      textField: {
        inputType: 'email',
        regexPattern: isRequired
          ? /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
          : /^$|^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        regexMessage: 'Please enter a valid email address',
      },
    },
  },
});
